import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { main } from 'routes/route.map'
import { toaster } from 'utils/toast-wrapper'

import SignupComponent from './component'

export default combine(
  withContext(
    'preRegistrationPublicService',
    ServicesContext,
    ({ preRegistrationPublicService }) => preRegistrationPublicService
  ),
  withCallbacks(
    {
      onSubmit:
        ({ preRegistrationPublicService }, { history }) =>
        async (registrationData) => {
          await preRegistrationPublicService.createPreRegSponsorPublic(
            registrationData
          )
          toaster.success('Your application has been sent')
          history.push(main.index())
        },
    },
    []
  )
)(SignupComponent)
